export const SSR_CATEGORIES = [
  {
    id: 1,
    code: "SEAT",
    name: "Seat",
    icon: "💺",
    description: "Seat selection and preferences",
    color: "#3b82f6"
  },
  {
    id: 2,
    code: "MEAL",
    name: "Meal",
    icon: "🍽️",
    description: "Special meal requests",
    color: "#10b981"
  },
  {
    id: 3,
    code: "HANDBAG",
    name: "Hand Baggage",
    icon: "👜",
    description: "Cabin baggage allowance",
    color: "#8b5cf6"
  },
  {
    id: 4,
    code: "BAGGAGE",
    name: "Baggage",
    icon: "🧳",
    description: "Checked baggage allowance",
    color: "#f59e0b"
  },
  {
    id: 5,
    code: "ASSIST",
    name: "Assistance",
    icon: "♿",
    description: "Special assistance services",
    color: "#ef4444"
  },
  {
    id: 6,
    code: "SPORT",
    name: "Sport Equipment",
    icon: "⛷️",
    description: "Sports and special equipment",
    color: "#06b6d4"
  },
  {
    id: 7,
    code: "PET",
    name: "Pet",
    icon: "🐕",
    description: "Pet travel services",
    color: "#ec4899"
  },
  {
    id: 8,
    code: "PERSONAL",
    name: "Personal Item",
    icon: "👝",
    description: "Personal item allowance (small bag, purse, laptop bag)",
    color: "#a855f7"
  },
  {
    id: 9,
    code: "OTHER",
    name: "Other",
    icon: "📋",
    description: "Other special services",
    color: "#6b7280"
  }
];

// SSR Items - Service-Level Data (CRUD)
export const SSR_ITEMS = [
  // Seat SSRs
  {
    id: "SSR-001",
    code: "EXST",
    description: "Extra Legroom Seat",
    category: "SEAT",
    maxWeight: null,
    maxSize: null,
    maxPieces: null,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15"
  },
  {
    id: "SSR-002",
    code: "PRST",
    description: "Preferred Seat",
    category: "SEAT",
    maxWeight: null,
    maxSize: null,
    maxPieces: null,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15"
  },

  // Meal SSRs
  {
    id: "SSR-003",
    code: "VGML",
    description: "Vegetarian Meal",
    category: "MEAL",
    maxWeight: null,
    maxSize: null,
    maxPieces: null,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-16",
    updatedAt: "2024-01-16"
  },
  {
    id: "SSR-004",
    code: "HNML",
    description: "Hindu Meal",
    category: "MEAL",
    maxWeight: null,
    maxSize: null,
    maxPieces: null,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-16",
    updatedAt: "2024-01-16"
  },
  {
    id: "SSR-005",
    code: "AVML",
    description: "Asian Vegetarian Meal",
    category: "MEAL",
    maxWeight: null,
    maxSize: null,
    maxPieces: null,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-16",
    updatedAt: "2024-01-16"
  },
  {
    id: "SSR-006",
    code: "KSML",
    description: "Kosher Meal",
    category: "MEAL",
    maxWeight: null,
    maxSize: null,
    maxPieces: null,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-16",
    updatedAt: "2024-01-16"
  },

  // Hand Baggage SSRs
  {
    id: "SSR-007",
    code: "CBAG",
    description: "Additional Cabin Bag",
    category: "HANDBAG",
    maxWeight: 7,
    maxSize: "55x40x23",
    maxPieces: 1,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-17",
    updatedAt: "2024-01-17"
  },

  // Baggage SSRs
  {
    id: "SSR-008",
    code: "XBAG",
    description: "Extra Baggage (23kg)",
    category: "BAGGAGE",
    maxWeight: 23,
    maxSize: "158cm",
    maxPieces: 1,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-18",
    updatedAt: "2024-01-18"
  },
  {
    id: "SSR-009",
    code: "XBAG32",
    description: "Extra Baggage (32kg)",
    category: "BAGGAGE",
    maxWeight: 32,
    maxSize: "158cm",
    maxPieces: 1,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-18",
    updatedAt: "2024-01-18"
  },

  // Assistance SSRs
  {
    id: "SSR-010",
    code: "WCHR",
    description: "Wheelchair - Ramp",
    category: "ASSIST",
    maxWeight: null,
    maxSize: null,
    maxPieces: null,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-19",
    updatedAt: "2024-01-19"
  },
  {
    id: "SSR-011",
    code: "WCHS",
    description: "Wheelchair - Steps",
    category: "ASSIST",
    maxWeight: null,
    maxSize: null,
    maxPieces: null,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-19",
    updatedAt: "2024-01-19"
  },
  {
    id: "SSR-012",
    code: "BLND",
    description: "Blind Passenger",
    category: "ASSIST",
    maxWeight: null,
    maxSize: null,
    maxPieces: null,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-19",
    updatedAt: "2024-01-19"
  },
  {
    id: "SSR-013",
    code: "DEAF",
    description: "Deaf Passenger",
    category: "ASSIST",
    maxWeight: null,
    maxSize: null,
    maxPieces: null,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-19",
    updatedAt: "2024-01-19"
  },

  // Sport Equipment SSRs
  {
    id: "SSR-014",
    code: "BIKE",
    description: "Bicycle",
    category: "SPORT",
    maxWeight: 15,
    maxSize: "150x90x30",
    maxPieces: 1,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-20",
    updatedAt: "2024-01-20"
  },
  {
    id: "SSR-015",
    code: "SKIS",
    description: "Ski Equipment",
    category: "SPORT",
    maxWeight: 23,
    maxSize: "200x40x30",
    maxPieces: 1,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-20",
    updatedAt: "2024-01-20"
  },
  {
    id: "SSR-016",
    code: "GOLF",
    description: "Golf Equipment",
    category: "SPORT",
    maxWeight: 15,
    maxSize: "158cm",
    maxPieces: 1,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-20",
    updatedAt: "2024-01-20"
  },
  {
    id: "SSR-017",
    code: "SURF",
    description: "Surfboard",
    category: "SPORT",
    maxWeight: 23,
    maxSize: "277cm",
    maxPieces: 1,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-20",
    updatedAt: "2024-01-20"
  },

  // Pet SSRs
  {
    id: "SSR-018",
    code: "PETC",
    description: "Pet in Cabin",
    category: "PET",
    maxWeight: 8,
    maxSize: "45x35x25",
    maxPieces: 1,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-21",
    updatedAt: "2024-01-21"
  },
  {
    id: "SSR-019",
    code: "AVIH",
    description: "Pet in Hold",
    category: "PET",
    maxWeight: 75,
    maxSize: "150x100x100",
    maxPieces: 1,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-21",
    updatedAt: "2024-01-21"
  },

  // Other SSRs
  {
    id: "SSR-020",
    code: "UMNR",
    description: "Unaccompanied Minor",
    category: "OTHER",
    maxWeight: null,
    maxSize: null,
    maxPieces: null,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-22",
    updatedAt: "2024-01-22"
  },
  {
    id: "SSR-021",
    code: "FRAG",
    description: "Fragile Baggage",
    category: "OTHER",
    maxWeight: 32,
    maxSize: "158cm",
    maxPieces: 2,
    flightSegmentRequired: true,
    travelerRequired: true,
    direction: "Both",
    status: "active",
    createdAt: "2024-01-22",
    updatedAt: "2024-01-22"
  }
];

export const DIRECTIONS = ["Outbound", "Inbound", "Both"];

export const getCategoryByCode = (code) => {
  return SSR_CATEGORIES.find(cat => cat.code === code);
};

export const getSSRItemsByCategory = (categoryCode) => {
  return SSR_ITEMS.filter(item => item.category === categoryCode);
};

export const getActiveSSRItems = () => {
  return SSR_ITEMS.filter(item => item.status === "active");
};